<script setup>
import {defineProps, ref} from 'vue';
import axios from "axios";
import {useAppStore} from "@/stores/app";
import authHeader from "@/services/auth-header";

const props = defineProps(['paymentStatus', 'visitStatus', 'paymentId', 'calendarItemId']);
const loading = ref(false);

function resendAdvancePaymentLink() {
  const data = { payment_id: props.paymentId, calendar_item_id: props.calendarItemId };
  loading.value = true;
  axios.post('ResendAdvancePaymentLink', data, authHeader()).then(() => {
    useAppStore().setIsSuccess('Pomyślnie wysłano link do płatności na Twój adres e-mail.');
  }).catch(err => {
    useAppStore().setIsAlert('Wystąpił błąd podczas wysyłania linku do ponownej płatności: ' + err.message);
  }).finally(() => {
    loading.value = false;
  });
}
</script>

<template>
  <div class="advance-payment-status">
    <span>Status zaliczki:</span>
    <span v-if="paymentStatus === 'success'" class="paid">Opłacona</span>
    <span v-else-if="paymentStatus === 'pending'" class="not-paid">Nieopłacona</span>
    <span v-else-if="paymentStatus === 'error'" class="payment-error">
      Błąd płatności
      <button v-if="visitStatus === 'open'" :disabled="loading" class="pay-button" @click="resendAdvancePaymentLink">Otrzymaj ponownie link do płatności</button>
    </span>
  </div>
</template>

<style scoped lang="scss">
.paid{
  color: green;
}
.not-paid{
  color: orange;
}
.payment-error{
  color: red;
}
.advance-payment-status{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}
.advance-payment-link{
  color: orange;
  text-decoration: underline;
  cursor: pointer;
}
.advance-payment-link:hover{
  text-decoration: none;
}
.pay-button{
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 10px;
}
</style>